/* Progressive enhancement: native content and form work without this component. */
if (!customElements.get('koko-about-motion')) {
  customElements.define('koko-about-motion', class extends HTMLElement {
    connectedCallback() {
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Map();
      this.pending = new Map();
      this.abort = new AbortController();
      if (this.motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.observer.unobserve(entry.target);
          const items = this.pending.get(entry.target) || [];
          const hero = entry.target.classList.contains('koko-about__planes');
          items.forEach((el, i) => {
            const vars = getComputedStyle(el);
            const x = vars.getPropertyValue('--fly-x').trim() || '0px';
            const y = vars.getPropertyValue('--fly-y').trim() || '45px';
            const animation = el.animate([
              { opacity: 0, transform: `translate3d(${x}, ${y}, 0) scale(.94)` },
              { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' }
            ], { duration: hero ? 1600 : 850, delay: hero ? 250 + i * 500 : i * 180, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' });
            el.style.opacity = '';
            this.animations.set(el, animation);
            animation.finished.then(() => { animation.cancel(); this.animations.delete(el); }).catch(() => {});
          });
          this.pending.delete(entry.target);
        }
      }, { threshold: .12 });
      this.querySelectorAll('.koko-about__planes, .koko-about__products').forEach(group => {
        const items = [...group.querySelectorAll('[data-fly-in]')];
        items.forEach(el => { el.style.opacity = '0'; });
        this.pending.set(group, items);
        this.observer.observe(group);
      });
      this.addEventListener('focusin', e => {
        const item = e.target.closest('[data-fly-in]');
        if (item) { item.style.opacity = ''; this.animations.get(item)?.cancel(); }
      }, { signal: this.abort.signal });
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.revealAll(); }, { signal: this.abort.signal });
    }
    revealAll() {
      this.observer?.disconnect();
      this.animations?.forEach(a => a.cancel());
      this.animations?.clear();
      this.querySelectorAll('[data-fly-in]').forEach(el => { el.style.opacity = ''; });
      this.pending?.clear();
    }
    disconnectedCallback() { this.revealAll(); this.abort?.abort(); }
  });
}
